import { render, staticRenderFns } from "./IdentificationForm.vue?vue&type=template&id=2afd397a&scoped=true&"
import script from "./IdentificationForm.vue?vue&type=script&lang=ts&"
export * from "./IdentificationForm.vue?vue&type=script&lang=ts&"
import style0 from "./IdentificationForm.vue?vue&type=style&index=0&id=2afd397a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afd397a",
  null
  
)

/* custom blocks */
import block0 from "./IdentificationForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports